<template>
  <app-layout>
     <template v-slot:headerTitle>
        Application Settings
    </template>
     <template v-slot:tallystatus>
          <div  v-show="tally_open_status=='false'">
                <i class="fa fa-times refresh" aria-hidden="true" ></i>
          </div>
           <div  v-show="tally_open_status=='true'">
                <i class="fas fa-check refresh" aria-hidden="true" ></i>
          </div>
     </template>
   
    <br>
    <template v-slot:tcsetttingnav>
    </template>
     <template v-slot:tcmainnav>
    </template>
    
  <div class="">
    <div class="md:grid md:grid-cols-3 md:gap-6  ">
      <div class="md:col-span-1">
        <div class="px-4 sm:px-0">
          <h3 class="text-lg font-medium leading-6 text-gray-900 "> Tally Connection Setting</h3>
          <p class="mt-1 text-sm text-gray-600">
            Enter the required information need to connect tally.
          </p>
        </div>
      </div>
      <div class="mt-5 mx-10 md:mt-0 md:col-span-2">
        <form action="#" method="POST">
          <div class="shadow sm:rounded-md sm:overflow-hidden">
            <div class="px-4 py-5 bg-white space-y-6 sm:p-6">
              <div class="grid grid-cols-3 gap-6">
                <div class="col-span-3 sm:col-span-2">
                  <DxForm :form-data="form_data" @field-data-changed="drop_down_change">
                            <DxSimpleItem
                                    data-field="ip_address"
                            />
                            <DxSimpleItem
                                    data-field="port_no"
                            />
                            <DxSimpleItem
                                    data-field="License_no"
                            />
                     </DxForm>
                </div>
              </div>
            </div>
         
             <DxToast
                        v-model:visible="isVisible"
                        v-model:message="messag"
                        v-model:type="type"
                      />
          </div>
        </form>
      </div>
    </div>
  </div>

  <div class="hidden sm:block" aria-hidden="true">
    <div class="py-5">
      <div class="border-t border-gray-200" />
    </div>
  </div>

<!-- Personal information -->
  <div class="mt-10 sm:mt-0">
    <div class="md:grid md:grid-cols-3 md:gap-6">
      <div class="md:col-span-1">
        <div class="px-4 sm:px-0">
          <h3 class="text-lg font-medium leading-6 text-gray-900">Personal Information</h3>
          <p class="mt-1 text-sm text-gray-600">
            Use a permanent address where you can receive mail.
          </p>
        </div>
      </div>
      <div class="mt-5 mx-10 md:mt-0 md:col-span-2">
        <form action="#" method="POST">
          <div class="shadow overflow-hidden sm:rounded-md">
            <div class="px-4 py-5 bg-white sm:p-6">
              <div class="grid grid-cols-6 gap-6">
              </div>
            </div>
            <div class="px-4 py-3 bg-gray-50 text-right sm:px-6">
              <button type="submit" class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                Save
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div class="hidden sm:block" aria-hidden="true">
    <div class="py-5">
      <div class="border-t border-gray-200" />
    </div>
  </div>
<!-- Notifications -->
  <div class="mt-10 sm:mt-0">
    <div class="md:grid md:grid-cols-3 md:gap-6">
      <div class="md:col-span-1">
        <div class="px-4 sm:px-0">
          <h3 class="text-lg font-medium leading-6 text-gray-900">Notifications</h3>
          <p class="mt-1 text-sm text-gray-600">
            Decide which communications you'd like to receive and how.
          </p>
        </div>
      </div>
      <div class="mt-5 mx-10 md:mt-0 md:col-span-2">
        <form action="#" method="POST">
          <div class="shadow overflow-hidden sm:rounded-md">
            <div class="px-4 py-5 bg-white space-y-6 sm:p-6">
            </div>
            <div class="px-4 py-3 bg-gray-50 text-right sm:px-6">
              <button type="submit" class="inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                Save
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div> 
  </app-layout>
</template>
<script>  
import JetNavLink from '@/Jetstream/NavLink.vue';
//import AppLayout from '@include/pages/BaseLayouts/tallyClinicAppLayout.vue';
import AppLayout from "@/Layouts/AppLayout.vue";
import BsEdit from "@/Base/BsEdit.vue";
import PageTitle from "@/Layouts/PageTitle.vue";
import DxTextBox from 'devextreme-vue/text-box';
import { DxToast } from 'devextreme-vue/toast';
import {getConfigurationCredentials,save_user_credentials} from './js/configuration.js';
import {isElectron} from "@include/pages/modules/UtilsJs/utils.js";
import {
    DxForm,
    DxSimpleItem,
    DxGroupItem,
} from 'devextreme-vue/form';
const modelData = {};
export default {
  props: {
    createDef: Array,
    moduleRoute: String,
    moduleName:  String,
    modelData:{
        type: Object,
        default: () => ({})
    },
  },
  components: {
    AppLayout,
    BsEdit,
    PageTitle,
    DxForm,
    DxSimpleItem,
    DxGroupItem,
    DxTextBox,
    JetNavLink,
    DxToast
  },
  data: function () {
    return {
      isVisible: false,
      message: '',
      toastType: 'info',
      form_data:{"ip_address":"","port_no":"","License_no":""},
      title:this.moduleRoute+" Create",
      isVisible: false,
      messag: '',
      type: 'info',
      metas:'',
    };
  },
  methods: {
    checkAction()
    {
      return (this.modelData.hasOwnProperty("id") && this.modelData.id != "")
    },
    checkTally(){
var _this=this;
    if(isElectron()){
              this.messag = this.message;
              this.is_electron = true;
              this.metas = "electron";
              window.api.send('checkTallyOpening'); 
              window.api.receive("checkTallyOpening-reply", (tally_response) => {
                    if(tally_response == "tally is not open"){
                          this.tally_is_open = false;
                          this.messag = tally_response;
                          this.isVisible = true;
                           getConfigurationCredentials(_this,this.metas,this.license_no);
                    }
                    else if(tally_response == "tally is open"){
                          this.tally_is_open = true;
                          getConfigurationCredentials(_this,this.metas,this.license_no);
                    }
              });
          }
          else{
              this.is_electron = false;
              this.messag = this.message;
              if(this.messag == "You Dont have a valid license number for this service"){
                this.isVisible = true; 
              }
              axios.post('/checkTallyIsOpen')
                .then((result) => {
                    if(result.data!="not_open"){
                          this.tally_is_open = true;
                    }
                    else{
                          this.tally_is_open = false;
                          this.messag = "tally is not open";
                          this.isVisible = true;
                    }
                })
          }
    },
    update()
    {
             var _this = this;
              save_user_credentials(this.form_data,_this);
             
    },
    submit() {
           
    },
  },
  mounted() {
     
  },
};
</script>
<style>
.main-content {
  background-color: #f3f4f6;
 
  margin-left: 212px;
  padding-bottom: 10px;
} 
.edit_view{
  height: 84vh;
}
.btn-close {
  position: absolute;
  top: 0;
  right: 0;
  border: none;
  font-size: 20px;
  padding: 10px;
  cursor: pointer;
  font-weight: bold;
  color: #2A66B1;
  background: transparent;
}
.modal-header {
  position: relative;
  border-bottom: 1px solid #EEEEEE;
  color: #2A66B1;
  justify-content: space-between;  
}
</style>